import { node, string } from 'prop-types';
import React from 'react';

const ModalBody = ({ children, className }) => {
	return <div className={`common-popup-body ${className}`}>{children}</div>;
};

ModalBody.propTypes = {
	children: node.isRequired,
	className: string
};

export default ModalBody;
